import React from "react";
import { Grid } from "@mui/material";
import { DatePickerField, DropDown, InputTextField } from "components/UI";
import { ModeAction } from "state/enum";

export default function CriterialSection(props) {
  const {
    mode,
    form,
    setForm,
    dataList: { importerData },
  } = props;

  const handleChangeImporter = e => {
    setForm(prev => ({
      ...prev,
      importerId: e.target.value,
    }));
  };

  return (
    <Grid container>
      <Grid container alignItems="center">
        <Grid item xs={5} style={{ display: "flex" }}>
          <strong style={{ margin: "auto 0px", width: "180px" }}>* Importer : </strong>
          <DropDown
            id="select-importer"
            fullWidth
            required
            defaultValue=""
            placeholder="<Select>"
            autoFocus={true}
            value={form?.importerId}
            onChange={handleChangeImporter}
            menu={importerData?.map(val => ({
              key: val?.companyId,
              value: val?.companyAbbr,
            }))}
            tabIndex={0}
            disabled={[ModeAction.ADD, ModeAction.EDIT].includes(mode)}
          />
        </Grid>
        <Grid item xs={1} />

        <Grid item xs={5} style={{ display: "flex" }}>
          <strong style={{ margin: "auto 0px", width: "180px" }}>Vessel Name : </strong>
          <InputTextField
            id="input_vessel_name"
            fullWidth={true}
            maxLength={40}
            value={form?.vesselName}
            tabIndex={0}
            onChange={e =>
              setForm(old => ({
                ...old,
                vesselName: e.target.value,
              }))
            }
            disabled={[ModeAction.ADD, ModeAction.EDIT].includes(mode)}
          />
        </Grid>

        <Grid item xs={5} style={{ display: "flex" }}>
          <strong style={{ margin: "auto 0px", width: "180px" }}>Invoice No. : </strong>
          <InputTextField
            id="input_invoice_no"
            fullWidth={true}
            maxLength={20}
            value={form?.invoiceNo}
            onChange={e =>
              setForm(old => ({
                ...old,
                invoiceNo: e.target.value,
              }))
            }
            tabIndex={0}
            disabled={[ModeAction.ADD, ModeAction.EDIT].includes(mode)}
          />
        </Grid>
        <Grid item xs={7} />

        <Grid item xs={5} style={{ display: "flex" }}>
          <strong style={{ margin: "auto 0px", width: "180px" }}>ETD (From) : </strong>
          <DatePickerField
            id="input_etd_from"
            className="input_etd_from"
            onChange={e =>
              setForm(old => ({
                ...old,
                etdFrom: e,
              }))
            }
            value={form?.etdFrom}
            tabIndex={0}
            disabled={[ModeAction.ADD, ModeAction.EDIT].includes(mode)}
            fullWidth
          />
        </Grid>
        <Grid item xs={1} />

        <Grid item xs={5} style={{ display: "flex" }}>
          <strong style={{ margin: "auto 0px", width: "180px" }}>ETD (To) : </strong>
          <DatePickerField
            id="input_etd_to"
            className="input_etd_to"
            onChange={e =>
              setForm(old => ({
                ...old,
                etdTo: e,
              }))
            }
            value={form?.etdTo}
            tabIndex={0}
            disabled={[ModeAction.ADD, ModeAction.EDIT].includes(mode)}
            fullWidth
          />
        </Grid>
        <Grid container spacing={1} />
      </Grid>
    </Grid>
  );
}
